import { SHORTCUT_DELIVERY_ZONE_FIELDS } from '@@partner:graphql/shortcuts'
import { DeliveryZone, GeoPoint, Shop } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useLazyQuery, useQuery } from '@apollo/client'

export type ShopsInGeoPolygonVariables = {
  corners: GeoPoint[]
} 

export type ShopsInGeoPolygonQuery = {
  shopsInGeoPolygon: Shop[]
}


export const GQL_QUERY_ZONES_IN_GEO_POLYGON = gql`
  query shopsInGeoPolygon(
    $corners: [GeoPointInput]!
  ) {
    shopsInGeoPolygon(
      corners: $corners
    ) {
        id
        xid
        slug
        name
        status
        phone

        minOrderCost
        
        workingHours
        tzOffset
        address
        shopGeoPoint {
          latitude
          longitude
        }
        
        shopOpenTime
        shopCloseTime
        tg_chat_id
        vkMaxChatId

        
        is_serving_wholesale
        is_serving_retail
    }
  }
`

export const useFetchShopsInGeoPolygon = (variables: ShopsInGeoPolygonVariables) => 
  useQuery<ShopsInGeoPolygonQuery, ShopsInGeoPolygonVariables>(GQL_QUERY_ZONES_IN_GEO_POLYGON, {
    variables,
    fetchPolicy: 'network-only'
  })

export const useLazyFetchShopsInGeoPolygon = () => useLazyQuery<ShopsInGeoPolygonQuery, ShopsInGeoPolygonVariables>(GQL_QUERY_ZONES_IN_GEO_POLYGON)